module.exports = __webpack_public_path__ + "img/Forwarders.9a5905de.gif";